import InvitedCard from './InvitedCard';

export default InvitedCard;
